<template>
  <div class="all-bg">
    <Search></Search>
    <CommonTab></CommonTab>
    <IndexCategory>
      <li>全部分类</li>
    </IndexCategory>
    <div class="category-container">
      <div class="category">
        <div class="category-item" v-for="item of categoryList" :key="item.id">
          <div class="title">{{ item.cate_name }}</div>
          <div class="content">
            <div class="content-item">
              <div class="content-name">病种类目</div>
              <div class="content-list">
                <span
                  v-for="val of item.children"
                  :key="val.id"
                  @click="thirdCategory(item.id, val.id)"
                  >{{ val.cate_name }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AuthModel :modelAuth="modelAuth"></AuthModel>
    <ThreeModel ref="modalThreeChild"></ThreeModel>
  </div>
</template>

<script>
import Search from "@/components/pc/Search";
import CommonTab from "@/components/pc/nav/CommonTab";
import IndexCategory from "@/components/pc/nav/IndexCategory";
import AuthModel from "@/components/pc/authenticate/AuthModel";
import ThreeModel from "@/components/pc/authenticate/ThreeModel";
import { getCategory } from "@api/public";
// import { getUserInfo } from "@api/user";
export default {
  name: "GoodsCategory",
  beforeRouteEnter(to, from, next) {
    window.scrollTo(0, 0);
    next();
  },
  data() {
    return {
      categoryList: [],
      modelAuth: false // 资质认证弹窗
    };
  },
  created() {
    getCategory().then(res => {
      this.categoryList = res.data;
    });
  },
  mounted() {},
  methods: {
    goDetail(id) {
      this.$router.push("/detail/" + id);

      // if (this.userInfo.is_certification === 0) {
      //   this.modelAuth = true;
      // } else if (this.userInfo.is_certification === 1) {
      //   this.$router.push("/detail/" + id);
      // } else if (this.userInfo.is_certification === 2) {
      //   this.$Modal.info({ content: "您的资质认证正在审核中" });
      // } else {
      //   this.$refs.modalThreeChild.newValue = true;
      // }
    },
    changeShowAuth() {
      this.modelAuth = false;
    },
    thirdCategory(mainId, secondId) {
      this.$router.push({
        name: "GoodsList",
        params: {
          mainId: mainId,
          secondId: secondId
        }
      });
    }
  },
  components: {
    Search,
    CommonTab,
    AuthModel,
    ThreeModel,
    IndexCategory
  }
};
</script>

<style lang="stylus" scoped>
.category-container
  background #fff
  .category
    width 1200px
    margin 0 auto
    padding-top 20px
    .category-item
      padding-bottom 30px
      .title
        font-size 18px
        color #555
        font-weight 550
        padding-bottom 10px
        border-bottom 1px solid #e4e4e4
        position relative
        &:after
          content ''
          display inline-block
          width 300px
          height 2px
          background #2977df
          position absolute
          bottom -1px
          left 0
      .content
        margin-top 15px
        line-height 24px
        font-family '宋体'
        .content-item
          display flex
          border-bottom 1px solid #e6e6e6
          padding 10px 0
          &:last-child
            border-bottom 0
          .content-name
            width 80px
            font-size 14px
            color #2977df
            font-weight bold
          .content-list
            flex 1
            display flex
            flex-wrap wrap
            span
              padding 0 10px 10px
              position relative
              font-size 13px
              color #666
              cursor pointer
              &:before
                content: ''
                display inline-block
                position absolute
                width 1px
                height 17px
                top 4px
                left 0
                background #e9e9e9
</style>
